export enum ApiStylesBehavior_AllowedMenuType {
    ALL = "all",
    EAT_IN = "eatIn",
    TAKE_AWAY = "takeAway"
}

export enum ApiStylesBehavior_ArticleViewType {
    TOGETHER = "together",
    SEPARATELY = "separately",
    GROUP_BY_TYPE = "groupByType"
}

export enum ApiGeneral_ScanArrowDirection {
    NO = "no",
    UP = "up",
    DOWN = "down",
    LEFT = "left",
    RIGHT = "right"
}
